const Fortmatic = () => (
    <svg
        width='28'
        height='29'
        viewBox='0 0 28 29'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        id='fortmatic'
    >
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M14 0H21H28V7.25999H21H14H6.99999V14.52V14.9855V21.7377V21.78V28.9977H0V21.78V21.7377V14.9855V14.52V7.25999V0H6.99999H14ZM21.0004 21.7399H14.0412V14.5223H27.9963V21.9939C27.9963 23.8513 27.2852 25.6326 26.0192 26.9464C24.7533 28.2602 23.0361 28.9988 21.2453 29H21.0004V21.7399Z'
            fill='white'
        />
    </svg>
);

export default Fortmatic;
